import { Directive, HostBinding, Input } from '@angular/core';

export type PayarcButtonVariant = 'primary' | 'secondary' | 'ghost' | 'destructive';

/** Apply to a native <button> / <a>: <button payarcButton="secondary">…</button> */
@Directive({
  selector: '[payarcButton]',
  standalone: false
})
export class PayarcButtonDirective {
  @Input('payarcButton') variant: PayarcButtonVariant | '' = 'primary';
  private get v(): PayarcButtonVariant { return (this.variant || 'primary') as PayarcButtonVariant; }

  @HostBinding('class.pa-btn') base = true;
  @HostBinding('class.pa-btn--primary')     get isPrimary()     { return this.v === 'primary'; }
  @HostBinding('class.pa-btn--secondary')   get isSecondary()   { return this.v === 'secondary'; }
  @HostBinding('class.pa-btn--ghost')       get isGhost()       { return this.v === 'ghost'; }
  @HostBinding('class.pa-btn--destructive') get isDestructive() { return this.v === 'destructive'; }
}
